export const BillingPaymentMethodKind = {
  Insurance: "insurance",
  SelfPay: "self-pay",
} as const;

export const BILLING_PAYMENT_METHOD_LABEL_INSURANCE = "Insurance";
export const BILLING_PAYMENT_METHOD_LABEL_SELF_PAY = "Self-Pay";
